import * as React from 'react';
import { connect } from 'react-redux';

import Error from '../../app/navigation/blades/error/Error';
import Origination from '../OriginationTemplate';

import '../../styles/app.scss';
import OriginationBlade from '../OriginationBlade';
import errorBoundaryApi from './errorBoundaryApi';

import { RootState } from '../../stories/store';

type State = {
    hasError: boolean;
    error: string;
    isApiCalledError: boolean;
};

interface StateToProps {
    bladeName: string;
}

interface IErrorBoundaryProps extends StateToProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, State> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: '', isApiCalledError: false };
    }

    async componentDidCatch(error: Error, errorInfo: React.ErrorInfo): Promise<void> {
        this.setState({
            hasError: true,
            error: error.message,
        });

        if (!this.state.isApiCalledError) {
            await errorBoundaryApi({
                payload: {
                    bladeName: this.props.bladeName,
                    errorMessage: this.state.error,
                    stackTrack: errorInfo.componentStack,
                    errorType: 'error',
                },
            });

            this.setState({
                isApiCalledError: true,
            });
        }
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error: error.message, isApiCalledError: false };
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return this.props.fallback
                ?? (
                    <Origination>
                        <OriginationBlade
                            key="errorBoundary"
                            id="errorBoundary"
                            fullWidth={false}
                        >
                            <Error />
                        </OriginationBlade>
                    </Origination>
                );
        }

        return this.props.children;
    }
}

const mapStateToProps = (state: RootState): StateToProps => (
    {
        bladeName: state.navigation.activatingBladeName || state.navigation.blades[state.navigation.blades.length - 1] || 'unknown',
    }
);

export default connect(mapStateToProps)(ErrorBoundary);
